import FloatingMenuPopup from '@/components/FloatingMenuPopup'
import { Typography } from '@mui/material'
import floatingMenuStyles from '@/components/FloatingMenuPopup/index.module.scss'
import { providerLabel } from './agentModelControlOptions'
import { MENU_GAP, MENU_WIDTH } from './AiAskBarHomeRightAgentSelect.constants'
import { agentSelectMenuPaperClass } from './agentSelectMenuPaperClass'

export default function AiAskBarHomeRightAgentSelectModelMenu({
  open,
  anchorEl,
  onClose,
  hoveredProvider,
  models,
  selection,
  onSelect,
}) {
  return (
    <FloatingMenuPopup
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      hideBackdrop
      restoreFocusOnClose={false}
      items={models.map((model) => ({
        id: model.value,
        label: model.label,
        selected: model.value === selection.selectedId,
      }))}
      onItemSelect={onSelect}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      menuListAriaLabel={hoveredProvider ? providerLabel(hoveredProvider) : 'Models'}
      paperClassName={agentSelectMenuPaperClass}
      paperSx={{ marginLeft: `${MENU_GAP}px`, width: MENU_WIDTH, minWidth: MENU_WIDTH }}
      header={
        hoveredProvider ? (
          <Typography component="span" variant="body2" className={floatingMenuStyles.menuTitle}>
            {providerLabel(hoveredProvider)}
          </Typography>
        ) : null
      }
    />
  )
}
